import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  xxs = 320;
  xs = 375;
  sm = 768;
  md = 992;
  lg = 1200;
  xl = 1400;

  constructor() {}

  // Less Than
  lt(width: number): boolean {
    return window.innerWidth < width;
  }

  // Less Than or Equal to
  lte(width: number): boolean {
    return window.innerWidth <= width;
  }

  // Greater Than
  gt(width: number): boolean {
    return window.innerWidth > width;
  }

  // Greater Than or Equal to
  gte(width: number): boolean {
    return window.innerWidth >= width;
  }
}
